export function moneyINR(n) {
  const v = Number(n || 0);
  try {
    return new Intl.NumberFormat("en-IN", {
      style: "currency",
      currency: "INR",
      maximumFractionDigits: 2,
    }).format(v);
  } catch {
    return `₹${(Math.round(v * 100) / 100).toLocaleString("en-IN")}`;
  }
}

export function prettyDate(iso) {
  if (!iso) return "—";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return String(iso);
  return d.toLocaleDateString("en-IN", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
}

export function statusLabel(inv) {
  const st = String(inv?.status || "").toLowerCase();
  const sub = String(inv?.current_sub_status || "").toLowerCase();

  if (sub === "overdue") return "OVERDUE";
  if (st === "paid") return "PAID";
  if (st === "partial" || sub === "partial") return "PARTIAL";
  if (st === "draft") return "DRAFT";

  // Fallbacks
  if (st) return st.toUpperCase();
  if (sub) return sub.toUpperCase();
  return "OPEN";
}

export function statusTone(inv) {
  const label = statusLabel(inv);
  if (label === "PAID") return "green";
  if (label === "OVERDUE") return "red";
  if (label === "PARTIAL") return "amber";
  if (label === "DRAFT") return "amber";
  return "blue";
}

export function isPayEnabled(inv) {
  return hasInvoiceLink(inv) && Number(inv?.balance || 0) > 0;
}

export function cn(...classes) {
  return classes.filter(Boolean).join(" ");
}

export function hasInvoiceLink(inv) {
  return !!inv?.invoice_url;
}